import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl, intlShape } from '../../../util/reactIntl';
import config from '../../../config';
import { Footer, PageBootstrap } from '../../../components';
import { Container, Row, Col } from 'react-bootstrap';
import Image from 'react-bootstrap/Image';

import { TopbarContainer } from '../..';
import metaImage from '../img/og/Niseko_ogimage1200.jpg';

import { propTypes } from '../../../util/types';

import '../AdventurePage.scss';

import skiImg from '../img/niseko/ski.webp';
import skiImg2 from '../img/niseko/ski2.webp';
import mountainImg2 from '../img/niseko/mountainImage2.webp';
import catImg from '../img/niseko/cat.webp';
import whiskeyImg from '../img/niseko/whiskey.webp';
import niseko1 from '../img/niseko/niseko1.webp';
import niseko2 from '../img/niseko/niseko2.webp';
import guide from '../img/niseko/tamaki.webp';
import cat2 from '../img/niseko/cat2.webp';
import accommodation1 from '../img/niseko/accommodation1.webp';
import accommodation2 from '../img/niseko/accommodation2.webp';
import accommodation3 from '../img/niseko/accommodation3.webp';
import accommodation4 from '../img/niseko/accommodation4.webp';
import accommodation5 from '../img/niseko/accommodation5.webp';
import accommodation6 from '../img/niseko/accommodation6.webp';
import youtube from '../img/niseko/youtube.webp';
import wrapper2 from '../img/niseko/wrapper2-2880-dark.webp';

import HeroImage from '../components/HeroImage';
import HeroContent from '../components/HeroContent';
import TourDetails from '../components/TourDetails';
import VideoThumbnail from '../components/VideoThumbnail';
import SectionComponent from '../components/SectionComponent';
import { ImageGalleryComponent } from '../components/Image';
import TwoColumnComponent from '../components/TwoColumnComponent';
import SingleColumnComponent from '../components/SingleColumnComponent';
import Subtitles from '../components/Subtitles';
import { getTourDetails } from '../utils';
import HighlightSection from '../components/HighlightSection';
import { cardsWinterAndSummer } from '../components/AdventureCard';
import { SuggestedAdventures } from '../components/SuggestedAdventures';

export const AdventurePageComponent = props => {
  const { intl } = props;
  const [isTransparent, setIsTransparent] = useState(true);

  // Schema for search engines (helps them to understand what this page is about)
  // http://schema.org
  // We are using JSON-LD format

  const schemaTitle = intl.formatMessage({ id: 'Niseko.OgTitle' });
  const schemaDescription = intl.formatMessage({ id: 'Niseko.OgDescription' });
  const schemaImage = `${config.canonicalRootURL}${metaImage}`;

  const inquireLink = config.custom.inquireURL.adventuresWinter('NisekoWinterAdventurePage');

  const imageList = [
    { src: accommodation1, alt: 'Accommodation image' },
    { src: accommodation2, alt: 'Accommodation image' },
    { src: accommodation3, alt: 'Accommodation image' },
    { src: accommodation4, alt: 'Accommodation image' },
    { src: accommodation5, alt: 'Accommodation image' },
    { src: accommodation6, alt: 'Accommodation image' },
  ];

  return (
    <PageBootstrap
      description={schemaDescription}
      title={schemaTitle}
      facebookImages={[{ url: metaImage }]}
      twitterImages={[{ url: schemaImage }]}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'NisekoAdventure',
        description: schemaDescription,
        name: schemaTitle,
        image: [schemaImage],
      }}
    >
      <TopbarContainer transparentBackground={isTransparent} />
      <Container fluid>
        <HeroImage
          src={wrapper2}
          onScrollPast={setIsTransparent}
          className="adventure-hero-md-position-niseko-winter"
        />
        <HeroContent
          titleId="NisekoAdventure.bannerText1"
          color="white"
          id="overview"
          alignment="center"
        />
      </Container>

      <Subtitles
        className="mt-5"
        subtitleIds={['NisekoAdventure.bannerText2', 'NisekoAdventure.bannerText3']}
      />
      <TourDetails details={getTourDetails('NisekoAdventure')} className="top-margin" />
      <SingleColumnComponent
        child={
          <div className="button-submit">
            <a
              className="w-100 text-center"
              href={inquireLink}
              id="btn_send_inquiry_1 d-flex justify-content-center align-items-center"
            >
              <FormattedMessage id="LandingPage.sendInquiryButton" />
            </a>
          </div>
        }
        columnSize={3}
        classNameCard="mt-3 pt-3"
      />

      <VideoThumbnail
        videoId="7fKEDm47yXo?si=rclO8OOhgVxQ7uk9"
        thumbnail={youtube}
        className="mt-5"
        transform="niseko_video_position"
      />

      <SectionComponent id="highlights" title="Highlights" wide fluid>
        <Image src={skiImg} alt="ski image" fluid />
        <SingleColumnComponent
          classNameRow="top-margin"
          classNameCard="no-padding-left-right-for-small-screen"
          child={
            <>
              <HighlightSection
                titleId="NisekoAdventure.highlights1"
                contentId="NisekoAdventure.highlights2"
              />
              <HighlightSection
                titleId="NisekoAdventure.highlights3"
                contentId="NisekoAdventure.highlights4"
              />
              <HighlightSection
                titleId="NisekoAdventure.highlights5"
                contentId="NisekoAdventure.highlights6"
              />
            </>
          }
        />
      </SectionComponent>

      <SectionComponent id="about" title="About" fluid>
        <TwoColumnComponent
          layoutType="intl"
          leftChild={['NisekoAdventure.about1', 'NisekoAdventure.about2', 'NisekoAdventure.about3']}
          rightChild={[
            'NisekoAdventure.includeList1',
            'NisekoAdventure.includeList2',
            'NisekoAdventure.includeList3',
            'NisekoAdventure.includeList4',
            'NisekoAdventure.includeList5',
            'NisekoAdventure.includeList6',
            'NisekoAdventure.includeList7',
            'NisekoAdventure.includeList8',
            ,
          ]}
          totalWidth={8}
          title={<FormattedMessage id="NisekoAdventure.aboutListTitle" />}
          renderIntLayoutRightCol="mt-4"
          renderIntlLayoutRightCard="two-column-card-small"
          rightCardBodyClass="padding-top"
          leftCardBodyClass="about-padding-left-right"
        />
        <Image src={skiImg2} alt="ski image" fluid />
      </SectionComponent>

      <SectionComponent id="area" title="Niseko" wide fluid>
        <Image src={mountainImg2} alt="mountain image" fluid />
        <SingleColumnComponent
          child={
            <>
              <p className="regular-text-area text-center text-start-small-screen">
                <FormattedMessage id="NisekoAdventure.niseko" />
              </p>
              <p className="regular-text-area text-center text-start-small-screen">
                <FormattedMessage id="NisekoAdventure.niseko1" />
              </p>
            </>
          }
          classNameCard="no-padding-left-for-small-screen"
        />
        <TwoColumnComponent
          layoutType="card"
          leftChild={[
            niseko1,
            { id: 'NisekoAdventure.niseko2', className: 'padding regular-text text-start mt-3' },
          ]}
          rightChild={[
            niseko2,
            { id: 'NisekoAdventure.niseko3', className: 'padding regular-text text-start mt-3' },
          ]}
          totalWidth={8}
          renderCardLayoutCardBody="paddingNone"
          rightCardBodyClass="paddingNone"
        />
      </SectionComponent>

      <SectionComponent id="guide" title="Guide" fluid>
        <TwoColumnComponent
          layoutType="card"
          leftChild={[{ url: guide, className: 'guide-pic responsive-img' }]}
          rightChild={[
            { id: 'NisekoAdventure.guide2', className: 'guide-name' },
            'NisekoAdventure.guide3',
          ]}
          totalWidth={12}
          renderCardLayoutCardBody="paddingNone"
          rightCardBodyClass="padding"
        />
        <SingleColumnComponent
          columnSize={12}
          child={
            <p className="italic-small text-center">
              <FormattedMessage id="NisekoAdventure.guide4" />
            </p>
          }
        />
        <Container className="mt-5">
          <Row className="justify-content-md-center paddingNoneImportant">
            <Col md={8}>
              <Image src={cat2} alt="cat image" fluid />
            </Col>
          </Row>
        </Container>
      </SectionComponent>

      <SectionComponent id="options" title="Options" fluid>
        <TwoColumnComponent
          layoutType="intl"
          leftChild={['NisekoAdventure.optionLeft1', 'NisekoAdventure.optionLeft2']}
          rightChild={[
            'NisekoAdventure.optionRight1',
            'NisekoAdventure.optionRight2',
            'NisekoAdventure.optionRight3',
            'NisekoAdventure.optionRight4',
            'NisekoAdventure.optionRight5',
            'NisekoAdventure.optionRight6',
            'NisekoAdventure.optionRight7',
            'NisekoAdventure.optionRight8',
          ]}
          totalWidth={8}
          renderIntLayoutRightCol="mt-4"
          renderIntlLayoutRightCard="two-column-card-small"
        />
        <div className="mb-5 mt-4">
          <Image src={catImg} alt="cat image" fluid />
        </div>

        <Image src={whiskeyImg} alt="whiskey image" fluid />
      </SectionComponent>

      <SectionComponent id="accommodations" title="Accommodations" fluid>
        <SingleColumnComponent
          columnSize={12}
          child={
            <p className="regular-text text-start padding">
              <FormattedMessage id="NisekoAdventure.accommodations" />
            </p>
          }
          classNameCard="px-0"
          classNameCol="px-0"
          classNameRow="px-0"
        />
        <ImageGalleryComponent imageList={imageList} />
      </SectionComponent>

      <SectionComponent id="" title="Summary">
        <TwoColumnComponent
          layoutType="intl"
          leftChild={[
            { id: 'NisekoAdventure.summaryLeft1', className: 'small-text-fine' },
            { id: 'NisekoAdventure.summaryLeft2', className: 'small-text-fine' },
          ]}
          rightChild={[
            'NisekoAdventure.summaryRightList1',
            'NisekoAdventure.summaryRightList2',
            'NisekoAdventure.summaryRightList3',
            'NisekoAdventure.summaryRightList4',
            'NisekoAdventure.summaryRightList5',
            'NisekoAdventure.summaryRightList6',
          ]}
          totalWidth={8}
          title={<FormattedMessage id="NisekoAdventure.summaryRightTitle" />}
          renderIntlLayoutLeftCard="two-column-card-white-background rounded7 h-100"
          leftCardBodyClass="d-flex flex-column justify-content-center align-items-center"
          renderIntlLayoutRightCard="mt-for-pc"
        />
      </SectionComponent>
      <SectionComponent id="" title="">
        <SingleColumnComponent
          child={
            <>
              <p className="small-text text-center mt-0 pt-0">
                <FormattedMessage id="NisekoAdventure.getStarted" />
              </p>
              <div className="button-submit">
                <a className="w-100" href={inquireLink} id="btn_send_inquiry_1">
                  <FormattedMessage id="LandingPage.sendInquiryButton" />
                </a>
              </div>
            </>
          }
          columnSize={8}
          classNameCard="mt-0 pt-0"
        />
      </SectionComponent>
      <SectionComponent title="More Adventures">
        <SuggestedAdventures cards={cardsWinterAndSummer} exclude="NisekoAdventurePage" />
      </SectionComponent>
      <Footer showBanner={false} />
    </PageBootstrap>
  );
};

const { bool, object } = PropTypes;

AdventurePageComponent.propTypes = {
  currentUser: propTypes.currentUser,

  // from withRouter
  history: object.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;
  return {
    currentUser,
  };
};

const mapDispatchToProps = dispatch => ({});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const AdventurePage = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(AdventurePageComponent);

export default AdventurePage;
